export enum SignInMethod {
    Unknown = 0,
    TouchId = 1,
    FaceId = 2
}


// WEBPACK FOOTER //
// ./src/model/types/signin-type.ts